import { getSimpleDataSelector } from '@cp-shared-19/frontend-integration';
import { RootState } from '../../store/rootReducer';

export const ContractContentSelector = getSimpleDataSelector((state: RootState) => state.content.contracts);
export const brandCatalogContentSelector = (state: RootState) => state.content.brands;
export const modelCatalogContentSelector = (state: RootState) => state.content.models;
export const productCatalogContentSelector = (state: RootState) => state.content.products;
export const AdditionalServicesDetailsContentSelector = getSimpleDataSelector(
    (state: RootState) => state.content.additionalServicesDetails,
);
